import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

import './plugins/vuetify'
import './plugins/moment'
import './plugins/firebase'
import './plugins/chart'
import './css/estilos.css'

import Toast from './shared/Toast'
import Alert from './shared/Alert'
import Loading from './shared/Loading'

import { conn } from './plugins/config'
import { momento } from './plugins/moment'

Vue.prototype.$axios = axios

axios.defaults.baseURL = conn

Vue.config.productionTip = false

Vue.component('app-toast', Toast)
Vue.component('app-alerta', Alert)
Vue.component('app-loading', Loading)

Vue.mixin({
  methods: {
    noted (color, texto) {
      store.commit('notaContent', {color: color, texto: texto})
      store.commit('nota', true)  
    }
  }
})

Vue.filter('fonificador', function (value) {
  let trim = value.trim().split('').reverse().join('')
  return trim.replace(/(\d{3})/g, '$1 ').replace(/(^\s+|\s+$)/, '').split('').reverse().join('')
})

Vue.filter('monificador', function (value) {
  return Number(value).toLocaleString('es')
})

Vue.filter('capitalizador', function (value) {
  return value.charAt(0).toUpperCase() + value.substr(1)
})

Vue.filter('rutificador', function (value) {
  let rut = value.split('').reverse().join('')
  let inverse = `${rut.slice(0, 1)}-${rut.slice(1, 4)}.${rut.slice(4, 7)}.${rut.slice(7, rut.length)}`
  return inverse.split('').reverse().join('')
})

Vue.filter('fechificador', function (value) {
  return momento(value).format('ddd DD MMMM')
})

Vue.filter('fullfecha', function (value) {
  return momento(value).format('ddd DD MMMM YYYY')
})

Vue.filter('fechayhora', function (value) {
  return momento(value).format('ddd DD MMMM YY | HH:mm')
})


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
